/* eslint-disable react-hooks/exhaustive-deps */
import { SolutionOutlined } from '@ant-design/icons';
import * as msal from '@azure/msal-browser';
import { Button, Form, Input, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import passWord from '../../../assets/icons/password.svg';
import userName from '../../../assets/icons/user_name.svg';
import * as SERVICE from '../../../constants/service.types';
import {
  APP_ID,
  AZURE_APP_ID,
  AZURE_REDIRECT_URI,
  AZURE_USER_NAME,
  GOOGLE_CLIENT_ID,
  GOOGLE_NAMESPACE,
  GOOGLE_USERNAME,
  NOTIFIES,
} from '../../../constants/system.keys';
import { openMessage, socketEmitEvent, updateNamespace, } from '../../../redux/actions';

const { Option } = Select;

const HOSTNAME = window.location.hostname
const LOGIN_FORM_CLASS = {
  "cloudcam1.hoasengroup.vn": {input: "hoasen-input", submit: "hoasen-submit", feedback: 'feedback hoasen-feedback', namespace: 'hoasen-namespace'}
}

const LoginByPhoneNumberComponent = ({ onBack }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const [formPassword] = Form.useForm();
  const [namespaces, setNamespaces] = useState();
  const [selectNamespace, setSelectNamespace] = useState();
  const [dataUserName, setDataUserName] = useState();
  const [, forceUpdate] = useState();
  const [step, setStep] = useState(0);
  const { t } = useTranslation();
  const refCountDown = useRef();
  const phonenumber = useRef(null);
  const password = useRef(null);
  const code = useRef(null);
  const [countDown, setCountDown] = useState(30);
  const [phone, setPhone] = useState();
  const [requestId, setRequestId] = useState();
  const { authData, listNamespaceAccount, authenticationAccount } = useSelector(
    (state) => state
  );
  const [stepPhone, setStepPhone] = useState(0);

  useEffect(() => {
    forceUpdate({});
  }, []);
  useEffect(() => {
    if (phonenumber.current) {
      phonenumber.current.input.focus();
    }
  }, [phonenumber]);
  useEffect(() => {
    if (password.current && step === 2) {
      password.current.input.focus();
    }
  }, [password, step]);
  useEffect(() => {
    if (code.current && step === 3) {
      code.current.input.focus();
    }
  }, [code, step]);
  useEffect(() => {
    if (countDown === 0) {
      clearInterval(refCountDown.current);
    }
  }, [countDown]);

  useEffect(() => {
    if (authenticationAccount && authenticationAccount.result < 0) {
      formPassword.setFields([
        {
          name: 'password',
          errors: [t('Password is incorrect!')],
        },
      ]);
    }
  }, [authenticationAccount, formPassword, t]);

  useEffect(() => {
    if (authData && authData.result !== 1) {
      form.setFields([
        {
          name: 'code',
          errors: [authData.message],
        },
      ]);
    }
    return () => {
      form.resetFields();
    };
  }, [authData, form]);

  useEffect(() => {
    if (listNamespaceAccount && requestId === listNamespaceAccount?.requestId) {
      if (listNamespaceAccount?.result === 1) {
        if (
          listNamespaceAccount?.data &&
          JSON.parse(listNamespaceAccount.data)?.length > 0
        ) {
          const loginResponseData = JSON.parse(listNamespaceAccount.data)[0];

          // login with microsoft azure
          if (loginResponseData.serviceId === 32) {
            handleLoginWithAzure(loginResponseData);
            return;
          }

          // login by google
          if (loginResponseData.serviceId === 55) {
            handleLoginWithGoogle(loginResponseData);
            return;
          }

          if (JSON.parse(listNamespaceAccount.data)?.length === 1) {
            const data = JSON.parse(listNamespaceAccount.data);
            setNamespaces(data);
            setSelectNamespace(data?.[0]?.namespace);
            if (data?.[0]?.type === 'ldap') {
              setStep(2);
              handleSelectNamespace();
            } else if (data?.[0]?.type === 'phone') {
              setStep(3);
              setStepPhone(1);
              handleConfirmPhoneNumber(dataUserName);
              setPhone(dataUserName);
              handleSelectNamespace();
            } else if (data?.[0]?.serviceId === 41) {
              //auth by password
              setStep(4);
              handleSelectNamespace();
            }
          } else {
            setStep(1);
            setNamespaces(JSON.parse(listNamespaceAccount.data));
          }
        } else {
          form.setFields([
            {
              name: 'userName',
              errors: [t('The account does not exist!')],
            },
          ]);
        }
      } else {
        form.setFields([
          {
            name: 'userName',
            errors: [t('Username is incorrect!')],
          },
        ]);
      }
    }
  }, [form, listNamespaceAccount, requestId, t]);

  const handleConfirmPhoneNumber = (phonenumber) => {
    if (phonenumber.length === 0) return;
    if (countDown && countDown > 0) {
      refCountDown.current = setInterval(() => {
        setCountDown((timer) => timer - 1);
      }, 1000);
    }
    let dataBody = {
      phonenumber,
      appId: APP_ID,
    };
    let dataObj = {
      appServiceType: SERVICE.GET_ACTIVATION_CODE,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    };
    return dispatch(socketEmitEvent(dataObj));
  };
  const handleConfirmCode = (code) => {
    if (code.length === 0) return;

    let dataBody = {
      activationCode: code,
      appId: APP_ID,
      namespace: selectNamespace,
      encrypted: 1,
      agent: `${window.navigator.userAgent}_web`,
    };

    let dataObj = {
      appServiceType: SERVICE.AUTHENTICATION,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const handleLogin = (values) => {
    const time = new Date().getTime();
    let dataBody = {
      username: values?.userName || '',
      appId: APP_ID,
    };
    let dataObj = {
      appServiceType: SERVICE.CHECK_LDAP_ACCOUNT,
      requestId: time,
      body: JSON.stringify(dataBody),
    };
    setRequestId(time);
    setDataUserName(values?.userName || '');
    return dispatch(socketEmitEvent(dataObj));
  };

  const handleLoginPhone = (values) => {
    handleConfirmCode(values.code);
  };

  const handlePasswordLDAP = (values) => {
    let dataBody = {
      appId: APP_ID,
      accountLdapId:
        namespaces?.find((item) => item?.namespace === selectNamespace)
          ?.accountLdapId ?? '',
      password: values.password,
      username: dataUserName,
      namespace: selectNamespace,
      language: localStorage.getItem('language') ?? 'vi',
    };
    let dataObj = {
      appServiceType: SERVICE.AUTHENTICATION_LDAP,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const handlePassword = (values) => {
    let dataBody = {
      appId: APP_ID,
      password: values.password,
      username: dataUserName,
      namespace: selectNamespace,
      language: localStorage.getItem('language') ?? 'vi',
    };
    let dataObj = {
      appServiceType: SERVICE.AUTHENTICATION_PASSWORD,
      requestId: new Date().getTime(),
      body: JSON.stringify(dataBody),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const handleLoginWithAzure = (loginResponseData) => {
    const { tenantId, applicationId } = loginResponseData;
    const msalConfig = {
      auth: {
        clientId: applicationId,
        authority: `https://login.microsoftonline.com/${tenantId}/`,
        redirectUri: AZURE_REDIRECT_URI,
      },
    };
    const msalInstance = new msal.PublicClientApplication(msalConfig);
    const msAccount =
      msalInstance.getAccountByUsername(dataUserName || '') || undefined;
    msalInstance
      .loginPopup({
        scopes: ['openid', 'profile', 'email', 'User.Read'],
        account: msAccount,
      })
      .then((azureResponse) => {
        let dataBody = {
          appId: APP_ID,
          localAccountId: azureResponse.account?.localAccountId,
          homeAccountId: azureResponse.account?.homeAccountId,
          environment: azureResponse.account?.environment,
          tenantId: azureResponse.account?.tenantId,
          username: azureResponse.account?.username,
          idTokenClaims: azureResponse.account?.idTokenClaims,
          name: azureResponse.account?.name,

          namespace: loginResponseData.namespace,
          language: localStorage.getItem('language') ?? 'vi',
        };
        let dataObj = {
          appServiceType: SERVICE.AUTHENTICATION_AZURE,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        dispatch(updateNamespace(loginResponseData.namespace));
        localStorage.setItem(AZURE_USER_NAME, dataUserName);
        localStorage.setItem(AZURE_APP_ID, applicationId);
        dispatch(socketEmitEvent(dataObj));
      })
      .catch((azureError) => {
        openMessage(NOTIFIES.WARNING, azureError.message);
      });
  };

  const handleLoginWithGoogle = (loginResponseData) => {
    const { clientId, namespace } = loginResponseData;

    localStorage.setItem(GOOGLE_CLIENT_ID, clientId);
    localStorage.setItem(GOOGLE_NAMESPACE, namespace);
    localStorage.setItem(GOOGLE_USERNAME, dataUserName);

    window.open(
      `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${window.location.origin}/login&&response_type=code&scope=email profile`,
      '_self'
    );
  };

  const handleResend = () => {
    if (phone) {
      setCountDown(30);
      clearInterval(refCountDown.current);
      handleConfirmPhoneNumber(phone);
    }
  };

  const handleSelectNamespace = () => {
    if (selectNamespace) {
      return dispatch(updateNamespace(selectNamespace));
    }
  };

  return (
    <>
      {step === 0 && (
        <div className="_2sd-step-login-component">
          <div />
          <Form
            className="form-login"
            form={form}
            size="large"
            name="form_login"
            onFinish={handleLogin}
          >
            <Form.Item
              name="userName"
              rules={[
                {
                  required: true,
                  message: t('Please enter user name!'),
                },
              ]}
            >
              <Input
                ref={phonenumber}
                prefix={
                  <img
                    src={userName}
                    alt="user-name"
                    className="site-form-item-icon"
                    color="blue"
                  />
                }
                placeholder={t('Enter user name')}
                className={LOGIN_FORM_CLASS[HOSTNAME]?.input || ''}
              />
            </Form.Item>
            <div className="confirm-btn">
              <Button
                shape="round"
                onClick={() => {
                  form.resetFields();
                  return onBack();
                }}
              >
                {t('Back')}
              </Button>
              <Form.Item shouldUpdate={true}>
                {() => (
                  <Button
                    shape="round"
                    htmlType="submit"
                    type="primary"
                    className={LOGIN_FORM_CLASS[HOSTNAME]?.submit || ''}
                    disabled={
                      !form.isFieldsTouched(true) ||
                      form
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length
                    }
                  >
                    {t('Continue')}
                  </Button>
                )}
              </Form.Item>
            </div>
          </Form>
          <div />
        </div>
      )}
      {step === 1 && (
        <div className="_3th-step-login-component">
          <div className="select-namespaces">
            <div />
            <Select
              className={LOGIN_FORM_CLASS[HOSTNAME]?.namespace || ''}
              style={{ width: '100%' }}
              loading={!namespaces}
              onSelect={(value) => setSelectNamespace(value)}
              size="large"
              placeholder={t('Select namespace')}
            >
              {namespaces &&
                namespaces.map((namespace, index) => (
                  <Option key={index} value={namespace.namespace}>
                    {namespace.namespace}
                  </Option>
                ))}
            </Select>
            <div />
          </div>
          <div className="confirm-btn">
            <Button
              shape="round"
              className="button-size-select"
              onClick={() => {
                setSelectNamespace(null);
                form.resetFields();
                setStep(0);
              }}
            >
              {t('Back')}
            </Button>
            <Button
              shape="round"
              className="button-size-select"
              type="primary"
              disabled={!selectNamespace}
              className={LOGIN_FORM_CLASS[HOSTNAME]?.submit || ''}
              onClick={() => {
                if (
                  namespaces?.find(
                    (item) => item?.namespace === selectNamespace
                  )?.type === 'ldap'
                ) {
                  setStep(2);
                  handleSelectNamespace();
                } else if (
                  namespaces?.find(
                    (item) => item?.namespace === selectNamespace
                  )?.type === 'phone'
                ) {
                  setStep(3);
                  setStepPhone(1);
                  handleConfirmPhoneNumber(dataUserName);
                  setPhone(dataUserName);
                  handleSelectNamespace();
                }
              }}
            >
              {t('Continue')}
            </Button>
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="_2sd-step-login-component">
          <div />
          <Form
            className="form-login"
            form={formPassword}
            size="large"
            name="form_login_password"
            onFinish={handlePasswordLDAP}
          >
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: t('Please enter password!'),
                },
              ]}
            >
              <Input
                ref={password}
                type="password"
                prefix={
                  <img
                    src={passWord}
                    alt="user-name"
                    className="site-form-item-icon"
                  />
                }
                className={LOGIN_FORM_CLASS[HOSTNAME]?.input || ''}
                placeholder={t('Enter password')}
              />
            </Form.Item>
            <div className="confirm-btn">
              <Button
                shape="round"
                onClick={() => {
                  formPassword.resetFields();
                  if (
                    listNamespaceAccount?.data &&
                    JSON.parse(listNamespaceAccount.data)?.length === 1
                  ) {
                    form.resetFields();
                    setStep(0);
                  } else {
                    setStep(1);
                    setSelectNamespace(null);
                  }
                }}
              >
                {t('Back')}
              </Button>
              <Form.Item shouldUpdate={true}>
                {() => (
                  <Button
                    shape="round"
                    htmlType="submit"
                    type="primary"
                    className={LOGIN_FORM_CLASS[HOSTNAME]?.submit || ''}
                    disabled={
                      !formPassword.isFieldsTouched(true) ||
                      formPassword
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length
                    }
                  >
                    {t('Continue')}
                  </Button>
                )}
              </Form.Item>
            </div>
          </Form>
          <div />
        </div>
      )}
      {step === 3 && (
        <div className="_2sd-step-login-component">
          <div />
          <Form
            className="form-login"
            form={form}
            size="large"
            name="form_login"
            onFinish={handleLoginPhone}
          >
            <Form.Item
              name="code"
              rules={[
                {
                  required: true,
                  message: t('Please enter the verification code'),
                },
              ]}
            >
              <Input
                ref={code}
                prefix={<SolutionOutlined className="site-form-item-icon" style={{color: "#0E9347"}} />}
                placeholder={t('Verification codes')}
                className={LOGIN_FORM_CLASS[HOSTNAME]?.input || ''}
              />
            </Form.Item>
            {stepPhone === 1 ? (
              <div className={LOGIN_FORM_CLASS[HOSTNAME]?.feedback || 'feedback'}>
                {countDown > 0 ? (
                  t('VERIFICATION_CODE_TIMER', { timer: countDown })
                ) : (
                  <span onClick={handleResend}>
                    {t("Don't receive verification code, resend again")}
                  </span>
                )}
              </div>
            ) : (
              <div className="feedback" />
            )}
            <div className="confirm-btn">
              <Button
                shape="round"
                onClick={() => {
                  form.resetFields();
                  if (
                    listNamespaceAccount?.data &&
                    JSON.parse(listNamespaceAccount.data)?.length === 1
                  ) {
                    form.resetFields();
                    setStep(0);
                  } else {
                    setStep(1);
                    setSelectNamespace(null);
                  }
                }}
              >
                {t('Back')}
              </Button>
              <Form.Item shouldUpdate={true}>
                {() => (
                  <Button
                    shape="round"
                    htmlType="submit"
                    type="primary"
                    className={LOGIN_FORM_CLASS[HOSTNAME]?.submit || ''}
                    disabled={
                      !form.isFieldsTouched(true) ||
                      form
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length
                    }
                  >
                    {t('Continue')}
                  </Button>
                )}
              </Form.Item>
            </div>
          </Form>
          <div />
        </div>
      )}

      {step === 4 && (
        <div className="_2sd-step-login-component">
          <div />
          <Form
            className="form-login"
            form={formPassword}
            size="large"
            name="form_login_password"
            onFinish={handlePassword}
          >
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: t('Please enter password!'),
                },
              ]}
            >
              <Input
                ref={password}
                type="password"
                prefix={
                  <img
                    src={passWord}
                    alt="user-name"
                    className="site-form-item-icon"
                  />
                }
                placeholder={t('Enter password')}
              />
            </Form.Item>
            <div className="confirm-btn">
              <Button
                shape="round"
                onClick={() => {
                  formPassword.resetFields();
                  if (
                    listNamespaceAccount?.data &&
                    JSON.parse(listNamespaceAccount.data)?.length === 1
                  ) {
                    form.resetFields();
                    setStep(0);
                  } else {
                    setStep(1);
                    setSelectNamespace(null);
                  }
                }}
              >
                {t('Back')}
              </Button>
              <Form.Item shouldUpdate={true}>
                {() => (
                  <Button
                    shape="round"
                    htmlType="submit"
                    type="primary"
                    className={LOGIN_FORM_CLASS[HOSTNAME]?.submit || ''}
                    disabled={
                      !formPassword.isFieldsTouched(true) ||
                      formPassword
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length
                    }
                  >
                    {t('Continue')}
                  </Button>
                )}
              </Form.Item>
            </div>
          </Form>
          <div />
        </div>
      )}
    </>
  );
};

export default LoginByPhoneNumberComponent;
